



















































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {発注単位区分型, 発注有効区分値} from '@/type/wholesale/types';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {卸初期値, 卸型} from '@/type/wholesale/wholesale';
import SlipLineNoField from '@/components/atom/input/SlipLineNoField.vue';

@Component({
  components: {
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    AlertDialog,
    SlipLineNoField,
  },
})

export default class UpdateWholesale extends Vue {

  @Prop({default: false})
  private modal!: boolean;
  @Prop({default: 卸初期値})
  private wholesale!: 卸型;

  private 卸更新: 卸型 = {...this.wholesale};
  private 発注単位区分リスト: string[] = [
    発注単位区分型.箱,
    発注単位区分型.バラ,
  ];
  private アラートメッセージ: string[] = [];

  @Watch('modal')
  private changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal) {
      this.卸更新 = {...this.wholesale};
      this.openDialog('卸マスタ更新画面');
    }
  }

  @Emit('close-form')
  private closeForm(): void {
    this.clear();
    this.closeDialog('卸マスタ更新画面');
  }

  @Watch('卸更新.備蓄品発注有効区分')
  private watchStockpile(): void {
    if (this.卸更新.備蓄品発注有効区分 === 発注有効区分値.有効) {
      this.卸更新.医薬品発注有効区分 = 発注有効区分値.無効;
      this.卸更新.その他品発注有効区分 = 発注有効区分値.無効;
    }
  }

  @Watch('卸更新.医薬品発注有効区分')
  private watchMedicine(): void {
    if (this.卸更新.医薬品発注有効区分 === 発注有効区分値.有効) {
      this.卸更新.備蓄品発注有効区分 = 発注有効区分値.無効;
    }
  }

  @Watch('卸更新.その他品発注有効区分')
  private watchOther(): void {
    if (this.卸更新.その他品発注有効区分 === 発注有効区分値.有効) {
      this.卸更新.備蓄品発注有効区分 = 発注有効区分値.無効;
    }
  }

  private openDialog(name: string): void {
    this.$modal.show(name);
  }

  private closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  private updateHandler(): void {
    progress(this.update);
  }

  private async update(): Promise<void> {
    if (this.卸更新) {
      await api.卸を更新する(this.卸更新)
        .then(
          () => {
            this.closeDialog('確定ダイアログ');
            this.closeForm();
          },
          (error: any) => {
            this.closeDialog('確定ダイアログ');
            if (error.data.errors) {
              this.アラートメッセージ = error.data.errors;
            }
            if (error.data.message && !error.data.errors) {
              this.アラートメッセージ = [error.data.message];
            }
            this.openDialog('卸更新アラート');
          },
        );
    }
  }

  private clear(): void {
    this.init();
    this.closeDialog('クリアダイアログ');
  }

  private init(): void {
    this.卸更新 = {...this.wholesale};
    this.アラートメッセージ = [];
  }

  private get isDeleted(): boolean {
    if (this.wholesale === null) {
      return false;
    }
    return this.wholesale.削除フラグ === '削除';
  }

  private get isEOS(): boolean {
    if (this.wholesale === null) {
      return false;
    }
    if (this.wholesale.EOS卸コード == null) {
      return false;
    }
    return this.wholesale.EOS卸コード !== '';
  }

  private get is備蓄センター(): boolean {
    if (this.wholesale === null) {
      return false;
    }
    if (this.wholesale.備蓄センターフラグ == null) {
      return false;
    }
    return this.wholesale.備蓄センターフラグ === '備蓄センター';
  }
}
